import React, { useMemo } from "react"
import { Accordion } from "react-bootstrap"
import { useTranslation } from "react-i18next"

import { AccordionIndicator } from "shared/ui/accordion/ui/AccordionIndicator"

import { VariantKeyDisplay } from "entities/products/ui/variant-key-display/VariantKeyDisplay"
import { useProductPositionFormProductInformationContext } from "widgets/product-position/product-position-form/contexts/ProductPositionFormProductInformationContext"

export function ProductPositionSidebarVariantKeyDisplay() {
  const { productInformation } =
    useProductPositionFormProductInformationContext()
  const { t } = useTranslation()

  const titleByProductType = useMemo(
    () =>
      Object.fromEntries(
        (productInformation?.addons ?? []).map(addon => [
          addon.productType,
          addon.title
        ])
      ),
    [productInformation?.addons]
  )

  return (
    <Accordion className="product-position-sidebar__variant-key-display">
      <Accordion.Item eventKey="variant-key">
        <Accordion.Button>
          {t("Product.VariantKey")}
          <AccordionIndicator />
        </Accordion.Button>
        <Accordion.Body>
          <VariantKeyDisplay
            title={productInformation?.title}
            variantKey={productInformation?.variantKey}
            addons={productInformation?.addons}
            titleByProductType={titleByProductType}
          />
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  )
}
